import React, { useState, Suspense, useEffect } from "react";

import { useLocalRoutes } from "./contexts/RoutesContext";

// react-router components
import { Routes, Route } from "react-router-dom";

import { loadPhotosJson, getUniSerialNumber } from "./utilities";
import PolicyBanner from "./components/PolicyBanner";

function App() {
  // const Home = React.lazy(() => import(`./pages/Home`));
  const AdminPanel = React.lazy(() => import(`./pages/AdminPanel`));

  // const [cities, setCities] = useState([]);
  // const [states, setStates] = useState([]);
  // const [years, setYears] = useState([]);

  const { localRoutes } = useLocalRoutes();

  // const dinamicRoutes = useRef({
  //   routes: [
  //     {
  //       name: "home",
  //       path: "/",
  //       subPath: [],
  //       element: <Home title={process.env.REACT_APP_APP_NAME} />,
  //     },
  //     {
  //       name: "home",
  //       path: "/home",
  //       subPath: [],
  //       element: <Home title={process.env.REACT_APP_APP_NAME} />,
  //     },
  //     {
  //       name: "category",
  //       path: "/photos/category/all",
  //       element: <Category title={`${process.env.REACT_APP_APP_NAME}`} />,
  //       subPath: [
  //         {
  //           name: "Natura",
  //           path: `/${process.env.REACT_APP_ROUTE_PHOTO_NATURA}&subtitle=Tutto_sul_mondo_della_natura`,
  //           element: "",
  //         },
  //       ],
  //     },
  //     {
  //       name: "photo",
  //       path: "/photos/:params",
  //       subPath: [],
  //       element: <Photos title={`${process.env.REACT_APP_APP_NAME}`} />,
  //     },
  //     {
  //       name: "about me",
  //       path: "/about-me",
  //       subPath: [],
  //       element: <AboutMe title={`${process.env.REACT_APP_APP_NAME}`} />,
  //     },
  //   ],
  // });

  useEffect(() => {
    const jsonPhotoOrigin = loadPhotosJson();

    // setCities([]);
    // setStates([]);
    // setYears([]);

    const cities = [];
    const states = [];
    const years = [];

    jsonPhotoOrigin.foto.map((photo) => {
      if (!cities.includes(photo.city)) cities.push(photo.city);
      if (!states.includes(photo.state)) states.push(photo.state);
      if (!years.includes(photo.year)) years.push(photo.year);
      return null;
    });

    //li salvo nel session storage
    window.sessionStorage.setItem("all_cities", cities);
    window.sessionStorage.setItem("all_states", states);
    window.sessionStorage.setItem("all_years", years);

    // setCities(cities);
    // setStates(states);
    // setYears(years);
  }, []);

  // useEffect(()=>{
  //   if(dinamicRoutes) writeDinamicRoutes();
  // },[dinamicRoutes])

  const writeDinamicRoutes = () => {
    // console.log(localRoutes);
    return localRoutes.routes?.map((route) => {
      return (
        <Route path={route.path} element={route.element} key={getUniSerialNumber()} />
      );
    });
  };

  return (
    <>
      <Suspense fallback={<></>}>
        <Routes>
          {/* {console.log(dinamicRoutes.current ? "c'è" : "nope")} */}
          {localRoutes ? writeDinamicRoutes() : null}
          {/* <Route path="/" element={<Home title={process.env.REACT_APP_APP_NAME} />} /> */}
          {/* 
          <Route path="/home" element={<Home title={process.env.REACT_APP_APP_NAME} />} />
          <Route
            path="/photos/category/:category"
            element={<Category title={`${process.env.REACT_APP_APP_NAME}`} />}
          />
          <Route
            path="/category/all"
            element={<Category title={`${process.env.REACT_APP_APP_NAME}`} />}
          />
          <Route
            path="/photos/:params"
            element={<Photos title={`${process.env.REACT_APP_APP_NAME}`} />}
          />
          <Route
            path="/about-me"
            element={<AboutMe title={`${process.env.REACT_APP_APP_NAME}`} />}
          /> */}
          <Route
            path="/admin/panel"
            element={<AdminPanel title={`${process.env.REACT_APP_APP_NAME}`} />}
          />

          {/* <Route path="*" element={<Home />} /> */}
          {/* <Route path="/serviceWorker" element={serviceWorker} /> */}
        </Routes>
      </Suspense>
      <PolicyBanner />
    </>
  );
}

export default App;
